var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Bar,{staticClass:"tw-w-full",attrs:{"chart-id":`chart-${_vm.reportName}`,"dataset-id-key":"label","chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }